import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getAllDistrictBihar, getDistrict, getStates } from '../../../services/monthlyAttendanceService';
import { getBlocksBasedOnsubId, getGodownListByBlockId, getsubdivisionsBasedonDid, updatetheGodowns } from '../../../services/godownLatLongService';
import { capitalizeFirstLetter, isValidLatitude, isValidLongitude } from '../../../utils/validations';
import './LatLongUpdate.css';
import { useNavigate } from 'react-router-dom';

const LatLongUpdate = () => {
    const [state, setState] = useState(3);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [districtId, setDistrictId] = useState(null);
    const [subDivisionOptions, setSubDivisionOptions] = useState([]);
    const [subDivisionId, setSubDivisionId] = useState(null);
    const [blockOptions, setBlocksOptions] = useState([]);
    const [blockId, setBlockId] = useState(null);
    const [godownData, setGodownData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [updatingGodownId, setUpdatingGodownId] = useState(null);
    const [tempLat, setTempLat] = useState('');
    const [tempLong, setTempLong] = useState('');
    const navigate = useNavigate();

    // Fetch Districts
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const res = await getStates();
                setStateOptions(res.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                console.error('Error fetching states:', err);
            }
        };

        fetchStates();
    }, []);

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            if (state) {
                try {
                    const data = await getDistrict(state);
                    const formattedOptions = data.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    }));
                    setDistrictOptions(formattedOptions);
                } catch (err) {
                    console.error('Error fetching districts:', err);
                }
            }
        };
        fetchDistricts();
    }, [state]);


    // Fetch Subdivisions
    useEffect(() => {
        const fetchSubdivisions = async () => {
            if (!districtId) {
                setSubDivisionOptions([]);
                return;
            }
            try {
                const data = await getsubdivisionsBasedonDid(districtId);
                setSubDivisionOptions(data.map(sub => ({
                    value: sub.id,
                    label: capitalizeFirstLetter(sub.subDivisionName)
                })));
            } catch (err) {
                console.error('Error fetching Subdivisions:', err);
            }
        };
        fetchSubdivisions();
    }, [districtId]);

    // Fetch Blocks
    useEffect(() => {
        const fetchBlocks = async () => {
            if (!subDivisionId) {
                setBlocksOptions([]);
                return;
            }
            try {
                const data = await getBlocksBasedOnsubId(subDivisionId);
                setBlocksOptions(data.map(blo => ({
                    value: blo.id,
                    label: capitalizeFirstLetter(blo.blockName)
                })));
            } catch (error) {
                console.error('Error fetching Blocks:', error);
            }
        };
        fetchBlocks();
    }, [subDivisionId]);

    const fetchGodownTable = async (selectedBlockId) => {
        if (!selectedBlockId) return;
        setLoading(true);
        try {
            const data = await getGodownListByBlockId(selectedBlockId);
            setGodownData(data || []);
        } catch (error) {
            console.error('Error fetching godown list:', error);
            alert("Failed to fetch godown list.");
            setGodownData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleFetch = () => {
        if (!blockId) {
            alert("Please select a Block first!");
            return;
        }
        fetchGodownTable(blockId);
    };

    const handleReset = () => {
        setDistrictId(null);
        setSubDivisionId(null);
        setBlockId(null);
        setGodownData([]);
        setUpdatingGodownId(null);
        setState("");
    };

    // Start Editing Lat/Long
    const handleUpdateClick = (godown) => {
        setUpdatingGodownId(godown.godownId);
        setTempLat(godown.latitude || '');
        setTempLong(godown.longitude || '');
    };

    // Save Updated Location (PATCH)
    const handleSaveLocation = async (godownId) => {
        // 1. Basic empty check
        if (tempLat === '' || tempLong === '') {
            alert("Please enter both Latitude and Longitude");
            return;
        }

        const lat = parseFloat(tempLat);
        const lng = parseFloat(tempLong);

        // 2. Range Validation
        if (lat < -90 || lat > 90) {
            alert("Latitude must be between -90 and 90.");
            return;
        }
        if (lng < -180 || lng > 180) {
            alert("Longitude must be between -180 and 180.");
            return;
        }

        // 3. Your specific condition: Longitude is not less than Latitude
        if (lng < lat) {
            alert("Validation Error: Longitude cannot be less than Latitude.");
            return;
        }

        try {
            const payload = {
                latitude: lat,
                longitude: lng
            };

            await updatetheGodowns(godownId, payload);
            alert("Location updated successfully!");

            fetchGodownTable(blockId);
            setUpdatingGodownId(null);
        } catch (error) {
            console.error("Error updating location:", error);
            alert("Failed to update location.");
        }
    };

    const handleCancelUpdate = () => {
        setUpdatingGodownId(null);
        setTempLat('');
        setTempLong('');
    };
    const handleStateChange = (selectedOption) => {
        setState(selectedOption ? selectedOption.value : null);
        setSubDivisionId("");
        setDistrictId("");
    }
    const gotoCreationLatLong = () => {
        navigate("/latLongCreation")
    }

    return (
        <div className="lat-long-container-update">
            <div className="form-card-update">
                <h2 className="form-title-update">Update Godown </h2>
                {/* <div className='navigate-btn'>
                    <button type='button' className='godown-btn-navigate' onClick={gotoCreationLatLong}>Add Godown</button>
                </div> */}
                <div className="form-grid-update">
                    <div className="input-group-lat-long-update">
                        <div className={`custom-select-update ${state ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={stateOptions}
                                value={stateOptions.find(opt => opt.value === state) || null}
                                onChange={handleStateChange}
                            />
                        </div>
                        <label><span className="reqiured">*</span> State</label>
                    </div>
                    <div className="input-group-lat-long-update">
                        <div className={`custom-select-update ${districtId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={districtOptions}
                                value={districtOptions.find(opt => opt.value === districtId) || null}
                                onChange={(opt) => setDistrictId(opt?.value || null)}
                            />
                        </div>
                        <label><span className="reqiured">*</span> District</label>
                    </div>

                    <div className="input-group-lat-long-update">
                        <div className={`custom-select-update ${subDivisionId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={subDivisionOptions}
                                value={subDivisionOptions.find(opt => opt.value === subDivisionId) || null}
                                onChange={(opt) => setSubDivisionId(opt?.value || null)}
                            />
                        </div>
                        <label><span className="reqiured">*</span> Sub Division</label>
                    </div>

                    <div className="input-group-lat-long-update">
                        <div className={`custom-select-update ${blockId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select-update"
                                placeholder=" "
                                isClearable
                                options={blockOptions}
                                value={blockOptions.find(opt => opt.value === blockId) || null}
                                onChange={(opt) => setBlockId(opt?.value || null)}
                            />
                        </div>
                        <label><span className="reqiured">*</span> Block</label>
                    </div>


                </div>
                <div className="input-group-lat-long-update">
                    <div className="button-group-lat-update">
                        <button
                            className="btn btn-primary-lat-update"
                            onClick={handleFetch}
                            disabled={loading || !blockId}
                        >
                            {loading ? 'Fetching...' : 'Fetch Godowns'}
                        </button>
                        <button
                            className="btn btn-secondary-lat-update"
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                    </div>
                </div>
                {/* Godown Table */}

            </div>
            <div>
                {godownData.length > 0 && (
                    <div style={{ marginTop: '2.5rem' }}>
                        <h3>Godowns in Selected Block</h3>
                        <table className="godown-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Godown ID</th>
                                    <th>Godown Name</th>
                                    <th>Godown Type</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {godownData.map((godown, index) => (
                                    <tr key={godown.godownId || index}>
                                        <td>{index + 1}</td>
                                        <td>{godown.godownId || 'N/A'}</td>
                                        <td>{godown.godownName || 'N/A'}</td>
                                        <td>{godown.godownType || 'N/A'}</td>
                                        {/* Editable Latitude & Longitude */}
                                        {/* Latitude Input */}
                                        <td>
                                            {updatingGodownId === godown.godownId ? (
                                                <input
                                                    type="text" // Changed to text to handle string validation
                                                    value={tempLat}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (isValidLatitude(val)) {
                                                            setTempLat(val);
                                                        }
                                                    }}
                                                    className="custom-input-update"
                                                    placeholder="Latitude"
                                                />
                                            ) : (
                                                godown.latitude || '—'
                                            )}
                                        </td>

                                        {/* Longitude Input */}
                                        <td>
                                            {updatingGodownId === godown.godownId ? (
                                                <input
                                                    type="text" // Changed to text
                                                    value={tempLong}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (isValidLongitude(val)) {
                                                            setTempLong(val);
                                                        }
                                                    }}
                                                    className="custom-input-update"
                                                    placeholder="Longitude"
                                                />
                                            ) : (
                                                godown.longitude || '—'
                                            )}
                                        </td>

                                  

                                        <td>
                                            {updatingGodownId === godown.godownId ? (
                                                <>
                                                    <button
                                                        className="btn btn-primary-lat-update"
                                                        style={{ padding: '6px 12px', marginRight: '6px', fontSize: '0.85rem' }}
                                                        onClick={() => handleSaveLocation(godown.godownId)}
                                                    >
                                                        Save
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary-lat-update"
                                                        style={{ padding: '6px 12px', fontSize: '0.85rem' }}
                                                        onClick={handleCancelUpdate}
                                                    >
                                                        Cancel
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="btn btn-primary-lat-update"
                                                    style={{ padding: '6px 16px', fontSize: '0.9rem' }}
                                                    onClick={() => handleUpdateClick(godown)}
                                                >
                                                    Update Lat/Long
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {godownData.length === 0 && blockId && !loading && (
                    <p style={{ textAlign: 'center', marginTop: '2rem', color: '#666' }}>
                        No godowns found for the selected block.
                    </p>
                )}
            </div>

        </div>
    );
};

export default LatLongUpdate;